import { createElement } from 'react'
import ElastiCacheOptimization from '~/dashboard/aws_master_optimizations/elasticache_optimization'
import ReactController from './react_controller'

export default class AWSElasticacheOptimizationController extends ReactController {
  static values = {
    organizationId: String,
    masterOptimizationId: String,
    masterOptimizationStatus: String,
  }

  createComponent() {
    return createElement(ElastiCacheOptimization, {
      organizationId: this.organizationIdValue,
      masterOptimizationId: this.masterOptimizationIdValue,
      masterOptimization: {
        id: this.masterOptimizationIdValue,
        status: this.masterOptimizationStatusValue,
      },
    })
  }
}
